import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from '@tanstack/react-query';

import { DeleteConfirmationModal, ButtonComponent } from '../../shared';
import { Delete } from '../../../assets/svg';
import { deleteDocsRequest, popup } from '../../../utils';
import { DOC_REQUEST, QUERY_KEYS } from '../../../constants';

export const DocumentRequestOperation = ({ data }) => {
    const queryClient = useQueryClient();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const handleDeleteClick = useCallback(async () => {
        try {
            await deleteDocsRequest({ id: data.id });
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.DOCUMENTS], exact: false });
            popup('error', DOC_REQUEST.DELETED_MESSAGE);
            setIsDeleteModalOpen(false);
        } catch (error) {
            popup('error', error.message);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <>
            <div className='d-flex align-items-center justify-content-center options-set'>
                <ButtonComponent
                    className='border-0 p-0 bg-white'
                    type='button'
                    clickHandler={(e) => {
                        e.stopPropagation();
                        setIsDeleteModalOpen(true);
                    }}
                    id='action-btn'
                >
                    <Delete />
                </ButtonComponent>
            </div>
            {isDeleteModalOpen && (
                <DeleteConfirmationModal
                    isDeleteModal={isDeleteModalOpen}
                    setIsDeleteModal={setIsDeleteModalOpen}
                    selectedItemId={data.id}
                    handleDeleteClick={handleDeleteClick}
                    deleteButtonName={DOC_REQUEST.DELETE_BUTTON}
                />
            )}
        </>
    );
};

DocumentRequestOperation.propTypes = {
    data: PropTypes.object.isRequired,
    debouncedApiCall: PropTypes.func,
};
